
















































import _ from 'lodash';
import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {AxiosError, AxiosResponse} from 'axios';

import ActionHeader from './action-header.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';

import {CONFIG} from '@/config';
import {dateService, httpService, i18nService, notificationService} from '@/services';

import {
  NOTIFICATIONS_DELETE,
  NOTIFICATIONS_DELETE_ALL,
  NOTIFICATIONS_GET_ALL,
  NOTIFICATIONS_UPDATE
} from '@/store/modules/notifications/types';

@Component({
  components: {PageLoader, ActionHeader}
})
export default class NotificationsPage extends Vue {
  public parseToMoment = dateService.parseToMoment;
  public i18n = i18nService.i18n;

  @Action(NOTIFICATIONS_DELETE) deleteNotification: Function;
  @Action(NOTIFICATIONS_DELETE_ALL) deleteAllNotifications: Function;
  @Action(NOTIFICATIONS_UPDATE) updateNotifications: Function;
  @Getter(NOTIFICATIONS_GET_ALL) notifications: Array<any>;

  mounted() {
   // this.requestData();
  }

  get orderedNotifications() {
    return _.reverse(this.notifications);
  }

  public removeNotifications(id: number): void {
    httpService.http
        .post(`${CONFIG.URL.NEODASH_API}/api/notification/read/${id}`)
        .then(() => {
          this.deleteNotification(id);
        })
        .catch((err: AxiosError) => console.log(err.message));
  }

  public removeAllNotifications(): void {
    httpService.http
        .post(`${CONFIG.URL.NEODASH_API}/api/notification/readAll`)
        .then(() => {
          this.deleteAllNotifications();
        })
        .catch((err: AxiosError) => console.log(err.message));
  }

  private requestData(): void {
    this.deleteAllNotifications();
    httpService.http
        .get(`${CONFIG.URL.NEODASH_API}/api/notification`)
        .then((res: AxiosResponse) => {
          this.updateNotifications(_.map(res.data, d => ({
            id: d.id,
            createdAt: d.createdAt,
            type: notificationService.getNotificationColor(d.notificationType),
            icon: notificationService.getNotificationIcon(d.notificationType),
            title: this.i18n(`Upload.${_.capitalize(notificationService.getNotificationContext(d.notificationContext))}`),
            message: d.message
          })));
        })
        .catch((err: AxiosError) => console.log(err.message));
  }
}
